import { useIntl } from 'react-intl'

import { AxiosError } from 'axios'

import { useAppDispatch } from '../../../data/store'
import { setToastContent } from '../../data/ltToastAutoActions'
import { useUpdateNpTestPlanMeasuresMutation } from '../data/npTestPlansApi'
import { NpTestPlanMeasureEntry } from '../data/npTestPlanTypes'

export const useUpdateNpTestPlanMeasures = (episodeId?: string) => {
  const { formatMessage } = useIntl()
  const dispatch = useAppDispatch()
  const [update, { isLoading: isSaving }] = useUpdateNpTestPlanMeasuresMutation()

  const updateMeasures = async (measures: NpTestPlanMeasureEntry[]): Promise<boolean> => {
    if (!episodeId) {
      return false
    }
    try {
      await update({ episodeId, measures }).unwrap()
      return true
    } catch (error) {
      dispatch(
        setToastContent({
          text:
            (error as AxiosError<{ message?: string }>)?.response?.data?.message ||
            formatMessage({
              defaultMessage: "Your changes couldn't be saved. Please try again.",
              description: 'Toast error shown when editing the measures on a neuropsych test plan fails',
            }),
          toastType: 'error',
          id: 'NpTestPlan-updateMeasures-error',
        }),
      )
      return false
    }
  }

  return { updateMeasures, isSaving }
}
